const React = require("react")
const Info = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#60D669"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 8C11 7.44772 11.4477 7 12 7H12.01C12.5623 7 13.01 7.44772 13.01 8C13.01 8.55228 12.5623 9 12.01 9H12C11.4477 9 11 8.55228 11 8ZM10 12C10 11.4477 10.4477 11 11 11H12C12.5523 11 13 11.4477 13 12V15C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17H12C11.4477 17 11 16.5523 11 16V13C10.4477 13 10 12.5523 10 12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.30711 6.30711C5.42511 7.1891 5 8.79285 5 12C5 15.2071 5.42511 16.8109 6.30711 17.6929C7.1891 18.5749 8.79285 19 12 19C15.2071 19 16.8109 18.5749 17.6929 17.6929C18.5749 16.8109 19 15.2071 19 12C19 8.79285 18.5749 7.1891 17.6929 6.30711C16.8109 5.42511 15.2071 5 12 5C8.79285 5 7.1891 5.42511 6.30711 6.30711ZM4.89289 4.89289C6.4109 3.37489 8.80715 3 12 3C15.1929 3 17.5891 3.37489 19.1071 4.89289C20.6251 6.4109 21 8.80715 21 12C21 15.1929 20.6251 17.5891 19.1071 19.1071C17.5891 20.6251 15.1929 21 12 21C8.80715 21 6.4109 20.6251 4.89289 19.1071C3.37489 17.5891 3 15.1929 3 12C3 8.80715 3.37489 6.4109 4.89289 4.89289Z"
      />
    </svg>
  )
}

module.exports = {
  Info
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/toast/info.js